export default __webpack_public_path__ + "static/media/Becky 9781408340561.63bc715e.jpg";